import React from 'react';
import { ChatConfig } from '../types';
import { getBrandingColor } from '../utils/brandingUtils';

interface ChatHeaderProps {
  config: ChatConfig | null;
}

/**
 * Renders the header section of the chat interface.
 * Displays the chat title based on branding configuration.
 */
export const ChatHeader: React.FC<ChatHeaderProps> = ({ config }) => {
  return (
    <header 
      className="text-white py-1 px-3 shadow-sm z-10" 
      style={{ backgroundColor: getBrandingColor(config, 'primary') }}
    >
      <h1 className="text-base font-medium text-center m-0 py-0.5">
        {config?.branding?.chatTitle || config?.storeInfo?.name || 'MattressAI Chat'}
      </h1>
    </header>
  );
}; 